<template>
    <div class="report-holder-child">
        <loader v-if="isSearchLoading" style="z-index:10000" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
        <div class="card mb-4">
            <div class="card-header pb-0">
                <div class="row">
                    <div class="col-md-8 d-flex align-items-center">
                        <h6><i class="fas fa-chart-area"></i> Registration Activity</h6>
                    </div>
                </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
                <div class="filter-records-holder">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="py-3 text-xs">
                            <form @submit.prevent="SubmitSearchForm" class="px-4 pb-3">
                                <div class="row"> 
                                    <div class="col-md-3 mt-4">
                                        <label> 
                                            Filter By State
                                            &nbsp;
                                            <vsud-spinner-small v-if="isStateLoading"></vsud-spinner-small>
                                        </label>
                                        <select name="role" class="form-control" v-model="state_id"  @change="onChangeState(state_id)">
                                            <option value="" :selected="true" style="color:#ccc"> 
                                                <span v-if="isStateLoading" style="color:#CCC">... Loading</span> 
                                                <span v-else>. select </span>
                                            </option>
                                            <option 
                                                v-for="(item,index) in states"
                                                :value="item.id"
                                                :key="index">
                                                {{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-4">
                                        <label> Filter by LGA</label>
                                        <select name="LGA" class="form-control" v-model="localgov_id" :disabled="!this.localgovs.length>0" @change="onChangeLocalGov(localgov_id)">
                                            <option value="" :selected="true" style="color:#ccc"> 
                                                <span v-if="isStateLoading" style="color:#CCC">... loading</span> 
                                                <span v-else>. select </span>
                                            </option>
                                            <option 
                                                v-for="(item,index) in localgovs"
                                                :value="item.id"
                                                :key="index">
                                                {{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-4">
                                        <label> 
                                            Filter by Scheme
                                            &nbsp;
                                            <vsud-spinner-small v-if="isSchemeLoading"></vsud-spinner-small>
                                        </label>
                                        <select name="scheme" v-model="scheme_id" class="form-control">
                                            <option value="" :selected="true"> 
                                                <span v-if="isSchemeLoading">... loading</span> 
                                                <span v-else>. select </span>
                                            </option>
                                            <option 
                                                v-for="(item,index) in schemes"
                                                :value="item.id"
                                                :key="index">
                                                {{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-4">
                                        <label> Filter By Period</label>
                                        <select name="period" v-model="period" class="form-control" disabled>
                                            <option value="" :selected="true" style="color:#ccc">. select </option>
                                            <option value="all">All time</option>
                                            <option value="week">This week</option>
                                            <option value="month">This month</option>
                                        </select>
                                    </div>
                                    <div class="col-md-9"></div>
                                    <div class="col-md-3 mt-4">
                                        <label>&nbsp;&nbsp;&nbsp;</label>
                                        <div class="row">
                                            <div class="col-md-6 mb-4"><VsudButton class="form-control" color="success" variant="gradient"> Submit </VsudButton></div>
                                            <div class="col-md-6"><span class="btn mb-0 bg-gradient-secondary btn-md form-control" @click="SearchReset">Reset</span></div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="isSearchLoading==false && message=='' && isSearchActive==true">
            <div class="card-header pb-0">
                <div class="row">
                    <div class="col-md-8 d-flex align-items-center">
                        <div class="pt-1 pb-3">
                            <b><i class="fas fa-files"></i> Total Records :</b> {{rows}}, &nbsp;&nbsp;&nbsp; <b><i class="fas fa-file"></i> Per Page :</b> {{perPage}}
                        </div>
                    </div>
                    <div 
                        v-if="loggedInUser=='superadmin'||loggedInUser=='admin'||loggedInUser=='project_owner'" 
                        class="col-md-4" 
                        style="text-align:right">
                        <div class="row">
                            <div class="col-md-1">
                                <vsud-spinner-small v-if="isExportLoading"></vsud-spinner-small>  
                            </div>
                            <div class="col-md-6 mb-4">
                                <select :disabled="isExportLoading==true" name="status" class="form-control" v-model="export_type">
                                    <option value="csv" :selected="true">Export type ( csv )</option>                                            
                                    <option value="xls">xls</option>
                                    <option value="xlsx">xlsx</option>
                                </select>
                            </div>
                            <div class="col-md-5">
                                <button :disabled="isExportLoading==true" @click="exportCsvHref" class="btn mb-0 bg-gradient-info btn-mdt form-control">Export {{export_type}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
                <div class="table-data-holder">
                    <div class="table-responsive p-0">
                        <div class="filter-records-holder">
                            <div class="row">
                                <div class="col-md-12">
                                </div>
                            </div>
                        </div>
                        <table class="table align-items-center mb-0">
                            <thead>
                            <tr>
                                <th
                                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                    Enumerator
                                </th>
                                <th
                                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                    LGA
                                </th>
                                <th
                                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                    Ward
                                </th>
                                <th
                                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                    Count
                                </th>               
                                <th
                                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                    %
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="data in TableData"  :key="data.id">
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <h6 class="mb-0 text-sm" v-if="data.name!==null||data.name!==''">{{data.name}}</h6>
                                        <h6 class="mb-0 text-sm" v-else>...</h6>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <span class="mb-0 text-sm" v-if="data.local_government!==null&&data.local_government!==''">
                                            {{data.local_government}}
                                        </span>
                                        <span v-else>...</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <span class="mb-0 text-sm" v-if="data.ward!==null&&data.ward!==''">
                                            {{data.ward}}
                                        </span>
                                        <span v-else>...</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <div class="mb-0 text-sm">
                                            <span v-if="data.updated!==null&&data.updated!==''">
                                                {{data.updated}}
                                            </span>
                                            <span v-else>
                                                ...
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <h6 class="mb-0 text-sm">
                                            <span v-if="data.total!==null&&data.total!==''&&data.updated!==null&&data.updated!==''">
                                                {{ ( (data.updated/data.total) * 100 ).toFixed(2) }} 
                                            </span>
                                            <span v-else>
                                                ...
                                            </span>
                                        </h6>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="d-flex p-3">
                                        <h6 class="mb-0 text-sm">
                                            TOTAL
                                        </h6>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        ...
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        ...
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        <h6 class="mb-0 text-sm">
                                            {{TotalUpdated('updated').toLocaleString("en-US")}}
                                        </h6>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex px-3 py-1">
                                        ..
                                    </div>
                                </td> 
                            </tr>
                            </tbody>
                        </table>
                        <div class="p-3">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @click="handlePageChange(currentPage)" aria-controls="my-table"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card nodata-holder" v-else>
            <div class="card-body px-0 pt-0 pb-2">
                <vsud-nodata :message="message"></vsud-nodata>
            </div>
        </div>
    </div>
</template>
<script>
import VsudSpinner from "@/components/VsudSpinner.vue";
import VsudButton from "@/components/VsudButton.vue";
import VsudNodata from "@/components/VsudNodata.vue";
import AuthService from '@/services/auth.service.js';
import VsudPagination from "@/components/VsudPaginationNew.vue";
import VsudBadge from "@/components/VsudBadge.vue";
import VsudSpinnerSmall from "@/components/VsudSpinnerSmall.vue";
import moment from "moment";

export default {
  name : "enumerator-activity",
  data()
  {
    return {
      TableData : [],
      isLoading : false,
      isSearchLoading : false,
      isSearchActive : false,
      states : [],
      localgovs : [],
      schemes : [],
      period : '',
      state_id : '',
      localgov_id : '',
      scheme_id : '',
      export_url  : '',
      export_param : '',
      export_type : 'csv',
      export_file_name : '',
      isStateLoading : false,
      isSchemeLoading : false,
      isExportLoading : false,
      message : 'No search record yet',
      loggedInUser : '',
      loggedInConsultant : [], 
      perPage: 0,
      currentPage: 0,
      rows : 0
    }
  },

  components: 
  {
    VsudSpinner,
    VsudNodata,
    VsudPagination,
    VsudBadge,
    VsudButton,
    VsudSpinnerSmall,
  },

  created()
  {
    this.GetStates();
    this.getUserClass();
    this.getConsultantLoggedIn();
    this.GetSchemes();
    this.moment = moment;
  },

  methods :
  {
    async GetReports(page='')
    {
        this.isSearchLoading = true;
        const periodUrl = (this.period!=='') ? '&year='+this.period : '';
        const stateUrl = (this.state_id!=='') ? '&state_id='+this.state_id : '';
        const localgovUrl = (this.localgov_id!=='') ? '&local_government_id='+this.localgov_id : '';
        const schemeUrl = (this.scheme_id)? '&scheme_id='+this.scheme_id : '';
        const pageUrl = (page!==undefined&&page>0)? '&page='+page : '';
        const perPageUrl = '?perPage=100';
        const dataStatus = ''; // : Deprecated -  '&status[]=registered';
        const PreSetUrl = periodUrl+stateUrl+localgovUrl+schemeUrl+dataStatus;
        const SearchUrl = perPageUrl+pageUrl+PreSetUrl;

       try{

          console.log(SearchUrl);

          const response = await AuthService.getReportEnumeratorActivity(SearchUrl);

          if(response.data.enumerationActivity.length>0)
          {

            const groupBy = key => array => array.reduce((objectsByKeyValue, obj) => {
                const value = obj[key];
                objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                return objectsByKeyValue;
            }, {});

            const groupByLocalgov = groupBy('local_government');

            this.TableData = response.data.enumerationActivity;
            this.perPage = response.data.enumerationActivity.length;
            this.currentPage = 1;
            this.rows = response.data.enumerationActivity.length;
            this.message = '';

            // Console log
            console.log(
                JSON.stringify({
                    enumBylocalgov : groupByLocalgov(this.TableData),
                }, null, 2)
            );

            // Prepare export   
            const export_file_name = 'Reports'+this.getExportFilename();
            this.export_param = PreSetUrl+'&updated=true&filename='+export_file_name;
            this.export_file_name = export_file_name;
          }
          else
          {
            this.message = 'No data please try again xxx';
          }

          this.isSearchLoading = false;
       }
       catch(error){
        if(error)
        { 
          this.isSearchLoading = false;
          this.message  = error.message;
          console.log(error);
        }
       }
    },

    async GetSchemes()
    {
        this.isSchemeLoading = true;
        
        try
        {
            const response = await AuthService.getSchemes();
            this.schemes = response.data
            this.isSchemeLoading = false;
        }
        catch(error)
        {
            if(error)
            { 
                console.log(error);
            }

            this.isSchemeLoading = false;
        }
    },

    async GetStates()
    {
        this.isStateLoading = true;

        try
        {
            const response = await AuthService.getStates('?perPage=100');
            this.states = response.data
            this.isStateLoading = false;
        }
        catch(error)
        {
          if(error)
          { 
            console.log(error);
          }
            this.isStateLoading = false;
        }
    },

    onChangeState(stateId)
    {
        if(stateId!==null&&stateId!=='')
        {
            this.localgovs = []; this.localgov_id = '';
            this.wards = []; this.ward_id = '';

            const responseState = this.getByValue(this.states,stateId);

            if(responseState.localGovernments.length>0)
            {
                const localGovs = responseState.localGovernments;
                this.localgovs  = localGovs;
            }
        }
    },

    onChangeLocalGov(localgovId)
    {
        if(localgovId!==null&&localgovId!=='')
        {
            this.wards = []; this.ward_id = '';

            const responseLocalgov = this.getByValue(this.localgovs,localgovId);
        }
    },

    getByValue(arr, value) 
    {
        for (var i=0, iLen=arr.length; i<iLen; i++) {

            if (arr[i].id == value) return arr[i];
        }
    },

    handlePageChange(value) 
    {
        this.GetReports(value);
    },

    SubmitSearchForm()
    {
        this.isSearchActive = true; this.GetReports('');

        console.log('Active search');
    },

    SearchReset()
    {
        this.search_input = '';
        this.state_id = '';
        this.status = '';
        this.localgov_id = '';
        this.ward_id = '';
        this.start_date = '';
        this.end_date = '';
        this.scheme_id = '';
        this.consultant_id = '';
        this.enumerator_id = '';
        this.isSearchActive = false
        this.TableData = [];
        this.message= 'No search record yet';
        this.isSearchActive = false;
    },

    reloadPage()
    {
      location.reload();
    },

    getUserClass()
    {
      if(this.$store.getters.isLoggedIn)
      {
        this.loggedInUser = this.$store.getters.getUser.primaryRole.name;
      }
    },

    getConsultantLoggedIn()
    {
      if(this.$store.getters.isLoggedIn)
      {
        const consultant = [];

        if(this.$store.getters.getUser.consultant!==null)
        {
            consultant[0] = this.$store.getters.getUser.consultant;
        }

        this.loggedInConsultant = consultant;
      }
    },

    getExportFilename()
    {
        var ExportUrl = '';

        // State
        if(this.state_id!==''&&this.state_id!==null)
        {
            console.log('# Debug - State Export URL');
            console.log(this.states);

            for(var i=0; i<this.states.length; i++)
            {
                if(this.states[i].id==this.state_id)
                {
                    ExportUrl += '-'+this.states[i].name;
                }
            }
        }

        // Local Goverment
        if(this.localgov_id!==''&&this.localgov_id!==null)
        {
            for(var i=0; i<this.localgovs.length; i++)
            {
                if(this.localgovs[i].id==this.localgov_id)
                {
                    ExportUrl += '-'+this.localgovs[i].name;
                }
            }
        }

        // Ward
        if(this.ward_id!==''&&this.ward_id!==null)
        {
            for(var i=0; i<this.wards.length; i++)
            {
                if(this.wards[i].id==this.ward_id)
                {
                    ExportUrl += '-'+this.wards[i].name;
                }
            }
        }

        // Scheme
        if(this.scheme_id!==''&&this.scheme_id!==null)
        {
            for(var i=0; i<this.schemes.length; i++)
            {
                if(this.schemes[i].id==this.scheme_id)
                {
                    ExportUrl += '-'+this.schemes[i].name;
                }
            }
        }

        if(this.period!=='')
        {
            ExportUrl += '-'+this.period;
        }

        return ExportUrl;

    },

    async exportCsvHref()
    {
        this.isExportLoading = true;

        try
        {
            const param = '?type='+this.export_type+this.export_param;
            const blob = await AuthService.getExportUrlEndpoint(param);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.export_file_name+'.'+this.export_type;
            link.click();

            this.isExportLoading = false;
        }
        catch(error)
        {
            this.isExportLoading = false;

            if(error)
            { 
                console.log(error);

                alert('An error occured downloading report');
            }
        }
    },

    TotalUpdated(type)
    {
        var sum = 0;
        const data = this.TableData;

        for(var i=0 ; i<data.length; i++)
        {
            if(type=='total')
                sum += data[i].total;
            else if(type='updated')
                sum += data[i].updated;
            else if(type=='pending')
                sum += data[i].pending;
        }

        return sum;
    }
  }
};
</script>
